export const name = 'renderer' as const

export const STYLE_OVERRIDES_ID = 'STYLE_OVERRIDES_ID'
export const RendererPropsProviderSym = Symbol('RendererPropsProviderSym')
